var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29102 18.6077C7.29102 16.6277 7.29102 15.6376 7.69127 14.7674C8.09153 13.8972 8.84322 13.2528 10.3466 11.9642L11.8049 10.7142C14.5223 8.38509 15.8809 7.22052 17.4993 7.22052C19.1178 7.22052 20.4764 8.38509 23.1938 10.7142L24.6521 11.9642C26.1555 13.2528 26.9072 13.8972 27.3074 14.7674C27.7077 15.6376 27.7077 16.6277 27.7077 18.6077V24.7916C27.7077 27.5415 27.7077 28.9164 26.8534 29.7707C25.9991 30.625 24.6242 30.625 21.8743 30.625H13.1243C10.3745 30.625 8.99956 30.625 8.14529 29.7707C7.29102 28.9164 7.29102 27.5415 7.29102 24.7916V18.6077Z",
    stroke: "black",
    strokeOpacity: 0.67,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1452 30.625V22.875C21.1452 22.3227 20.6975 21.875 20.1452 21.875H14.8535C14.3012 21.875 13.8535 22.3227 13.8535 22.875V30.625",
    stroke: "black",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e8c39c73abbe9c77fc838404546b26d8.svg";
export { ForwardRef as ReactComponent };